import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import logoImage from '../../assets/img/logo.png';
import '../../assets/css/admin/admin-login.css';

const AdminLoginPage = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { login, isAuthenticated } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();

  // If already authenticated, redirect to dashboard
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/admin/dashboard';
      navigate(from);
    }
  }, [isAuthenticated, navigate, location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const result = await login(formData.email, formData.password);
      if (!result.success) {
        setError(result.message || 'Login failed');
      } else {
        // Redirect is handled by the useEffect hook
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page admin-area">
      <div className="container">
        <div className="row vh-100 justify-content-center align-items-center">
          <div className="col-md-6 col-lg-5 col-xl-4">
            <div className="card admin-card shadow">
              <div className="card-body p-4">
                <div className="text-center mb-4">
                  <img src={logoImage} alt="SPONO Logo" className="admin-login-logo" />
                  <h1 className="h3 mb-0 text-gradient">SPONO</h1>
                  <p className="text-muted">Admin Login</p>
                </div>
                
                <form onSubmit={handleSubmit}>
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}
                  
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      autoFocus
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Logging in...
                        </>
                      ) : (
                        'Login'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            
            <div className="text-center mt-3 text-muted">
              <small>&copy; {new Date().getFullYear()} SPONO. All rights reserved.</small>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx="true">{`
        .text-gradient {
          background: linear-gradient(to right, #ff3636, #c93e67);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
      `}</style>
    </div>
  );
};

export default AdminLoginPage;
